import { ColorSwatch } from 'foundations-components/transitional/components/ColorSwatch';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import EmptyPropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/EmptyPropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FormDesignColor({
  color
}) {
  if (!color) {
    return /*#__PURE__*/_jsx(EmptyPropertyValue, {});
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    justify: "end",
    children: [color, /*#__PURE__*/_jsx(ColorSwatch, {
      size: 10,
      color: color,
      marginInlineStart: "200"
    })]
  });
}